import { Application, CreateApplicationApiOptions } from '../../shared/models/application';
import EnrouteApiClient from '../../shared/services/enroute-api-client';
import { mapAxiosResponse } from '../../shared/utils/api-utils';

export default class ApplicationService {
  public static async create(options: CreateApplicationApiOptions): Promise<Application> {
    const response = await EnrouteApiClient.post(`/org/${ options.org_id }/create_application`, {
      type: options.type,
      name: options.name,
    });

    return mapAxiosResponse<Application>(response);
  }
}